import { Box, Grid, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  titulo: {
    fontSize: 24,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subtitulo: {
    fontSize: 18,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));

export default function ResponsiveContainer(props) {
  const classes = useStyles();
  return (
    <Grid
      container
      component={Paper}
      elevation={2}
      justifyContent="center"
      justifyContent="center"
      style={{
        maxWidth: '1000%',
        backgroundColor: '#fff',
        margin: 'auto',
        marginTop: '1em',
        padding: '1em 4em',
        marginBottom: '1em',
        width: '95%',
        borderRadius: '20px',
      }}
    >
      <Grid item xs={12}>
        <Box py={3}>
          <Grid container className={classes.titulo}>
            <Grid item>
              <Typography align="left" variant="h4">
                <Typography className={classes.titulo}>
                  {props.title}
                </Typography>
                <Typography className={classes.subtitulo}>
                  {props.subtitle2}
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12}>
        {props.children}
      </Grid>
    </Grid>
  );
}
